import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 导出代理清单
export function podFeeExcel(params) {
  return request({
    url: URL.seaExport.podFeeExcel,
    method: 'get',
    params,
    responseType: 'blob'
  })
}
